import Styles from './PaymentFailed.module.scss'
import PaySuccessStyles from './PaymentSuccessful.module.scss'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
// Module Import
import FeatherIcon from 'feather-icons-react';
// Components import
import { useTranslation } from 'components/lib';

export const PaymentFailed = () => {

    const { t } = useTranslation();
    const navigate = useNavigate();
    // const searchParams = new URLSearchParams(window.location.search);
    const [showRedirect, setShowRedirect] = useState(false)
    const [timer, setTimer] = useState(8)


    useEffect(() => {
        const redirectTimeout = setTimeout(() => {
            //if product purchased is account, then navigate them back to the home page
            navigate('/navigate')
        }, 8000);

        return () => clearTimeout(redirectTimeout);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        //if redirect doesn't happen in 15 secs give the option to click on a button to navigate back to home 
        const redirectTimeout = setTimeout(() => {
            setShowRedirect(true)
        }, 11000);
        return () => clearTimeout(redirectTimeout);
    }, [])

    const updateTime = () => {
        if (timer > 0) {

            setTimer(timer - 1)
        }
    }

    setTimeout(updateTime, 1000)

    return (
        <>
            <div className={Styles.parentContainer}>
                <div className={Styles.iconContainer}>
                    <FeatherIcon icon="x" size='90px' style={{ color: '#fff' }} />

                </div>
                <div className={Styles.cardContainer} >
                    <p style={{ marginTop: '2%' }}>
                        {t('Payment.PaymentFailed.failed')}
                    </p>
                    {showRedirect &&
                        <p id={Styles.redirect} className={Styles.invoiceNumber}>
                            <a href='/navigate'>{t('Payment.PaymentFailed.link.link')}</a> {t('Payment.PaymentFailed.link.text')}
                        </p>
                    }
                    {(!showRedirect && timer !== 0) &&
                        <p id={Styles.redirect} className={PaySuccessStyles.paymentSuccessText}>
                            {t('Payment.PaymentFailed.redirect', { timer: timer })}
                        </p>
                    }
                </div>
            </div>
        </>
    )
}